(function () {
    'use strict';

    function itemScroller($window, $timeout, $templateCache, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/itemScroller.html',
            transclude: true,
            scope: {
                items: '=',
                itemFillerContainerClass: '@'
            },
            link: function (scope, element, attrs) {
                function convertPxToInt(val) {
                    if (!val) {
                        return 0;
                    }
                    return parseInt(val.replace('px', ''), 10);
                }

                var fillerTemplateUrlAttrName = 'fillerTemplateUrl';
                if (attrs.hasOwnProperty(fillerTemplateUrlAttrName)) {
                    scope.fillerTemplateUrl = attrs[fillerTemplateUrlAttrName];
                }

                var visibilityContainerAttrName = "visibilityContainerName";
                if (attrs.hasOwnProperty(visibilityContainerAttrName)) {
                    scope.visibilityContainerName = attrs[visibilityContainerAttrName];
                }

                var defaultItemWidthAttrName = 'defaultItemWidth';
                if (attrs.hasOwnProperty(defaultItemWidthAttrName)) {
                    scope.defaultItemWidth = parseInt(attrs[defaultItemWidthAttrName], 10);
                }

                scope.visibiltityContainerName =
                scope.firstItemIndex = 0;
                scope.lastVisibleItemIndex = 100;
                scope.currentPosition = 0;
                scope.canGoBackward = false;
                scope.canGoForward = false;
                scope.itemCapacity = 0;
                scope.hiddenItemsCount = 0;
                scope.shownItemsCount = 0;

                var listElement = $(element).find('.scrolling-list')[0];
                var containerElement = $(element).find('.item-scroller-items-container')[0];

                function getItemActualWidth(item) {
                    return item.width() +
                        convertPxToInt(item.css('margin-left')) +
                        convertPxToInt(item.css('margin-right')) +
                        convertPxToInt(item.css('padding-left')) +
                        convertPxToInt(item.css('padding-right'));
                }

                function recalculateStyles() {
                    var containerLeft = $(containerElement).offset().left;
                    var containerRight = $(containerElement).offset().left +
                        getItemActualWidth($(containerElement));

                    if (!scope.defaultItemWidth) {
                        throw new Error('must set default item width');
                    }

                    scope.itemCapacity = Math.floor((containerRight - containerLeft) / scope.defaultItemWidth);
                    scope.fillerCount = scope.itemCapacity - Math.min(scope.itemCapacity, scope.items.length);
                    scope.lowerBound = scope.currentPosition;
                    scope.upperBound = scope.itemCapacity + scope.currentPosition;
                    scope.canGoForward = scope.fillerCount === 0 &&
                        (scope.currentPosition + scope.itemCapacity) < scope.items.length;
                    scope.canGoBackward = scope.currentPosition > 0;
                    $(listElement).css('left', (-1 * scope.currentPosition * scope.defaultItemWidth) + 'px');

                    scope.fillerRange = [];
                    if (scope.fillerCount && scope.fillerTemplateUrl) {
                        for (var i = 0; i < scope.fillerCount; i++) {
                            scope.fillerRange.push(i);
                        }
                    }
                }

                scope.moveForward = function () {
                    scope.currentPosition += 1;
                    recalculateStyles();
                }

                scope.moveBackward = function () {
                    scope.currentPosition -= 1;
                    recalculateStyles();
                }

                //angular.element($window).bind('resize', function () {
                //    scope.width = $window.innerWidth;

                //    // manuall $digest required as resize event
                //    // is outside of angular

                //    recalculateStyles();

                //    scope.$digest();
                //});

                $rootScope.$on('containerVisibilityChange',
                    function (event, args) {
                        if (args.containerName === scope.visibilityContainerName &&
                            args.isVisible) {
                            $timeout(function () {
                                recalculateStyles();
                            }, 500);
                        }
                    });

                scope.$watch(function () { return scope.items.length },
                    function (newVal, oldVal) {
                        recalculateStyles();
                    });

                $timeout(function () {
                    recalculateStyles();
                });
            }
        };
    }

    itemScroller.$inject = ['$window', '$timeout', '$templateCache', '$rootScope'];

    angular.module('ecap.common').directive('itemScroller', itemScroller);
})();
